export default {
  props: {
    listKey: String,
  },
}